var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { PureComponent } from 'react';
import { VideoContext } from './videoContext';
// import getVideoinfo from '../../utils/getVideoInfo';
import { mergeObj, canPlay, creatCallBackName, createUid } from '../../utils/util';
import jsonp from '../../../../base/base/jsonp';
class VideoContentProvider extends PureComponent {
    constructor(props) {
        super(props);
        this.playBtnDelayHide = () => {
            if (this.timer) {
                clearTimeout(this.timer);
            }
            this.timer = window.setTimeout(() => {
                this.setState({
                    playBtnShow: this.state.playBtnStatus === 'play' || this.state.playBtnStatus === 'ended',
                    titleShow: false,
                    controllShow: false,
                    shortTipsShow: false,
                }, () => {
                    this.maskShow = false;
                    if (this.timer) {
                        clearTimeout(this.timer);
                    }
                });
            }, 4000);
        };
        this.handleContentChange = (action) => {
            switch (action.type) {
                case 'changePlayBtnStatus':
                    return this.setState({
                        playBtnStatus: action.playBtnStatus,
                    }, () => {
                        this.playBtnDelayHide();
                        if (action.playBtnStatus === 'pause' && !this.posterHasShow) {
                            this.setState({
                                postShow: false,
                            }, () => {
                                this.posterHasShow = true;
                            });
                        }
                        if (action.playBtnStatus === 'ended') {
                            this.setState({ playBtnShow: true });
                        }
                    });
                case 'clickVideoDom':
                    return this.maskShow
                        ? this.setState({
                            playBtnShow: true,
                            titleShow: false,
                            controllShow: false,
                            shortTipsShow: false,
                        }, () => {
                            this.maskShow = false;
                        })
                        : this.setState({
                            playBtnShow: true,
                            titleShow: true,
                            controllShow: true,
                            shortTipsShow: true,
                        }, () => {
                            this.maskShow = true;
                            this.playBtnDelayHide();
                        });
                case 'updateCurrent':
                    return this.setState({
                        currentTime: action.currentTime,
                    });
                case 'swipControllBar':
                    if (this.timer) {
                        clearTimeout(this.timer);
                    }
                    return this.setState({
                        currentTime: action.currentTime,
                        playBtnStatus: 'pause',
                    }, () => {
                        if (action.callback) {
                            action.callback();
                        }
                        this.playBtnDelayHide();
                    });
                case 'videoTimeUpdate':
                    return this.setState({
                        playBtnStatus: 'pause',
                    });
                case 'updateVideoDuration':
                    return this.setState({
                        videoConfig: Object.assign(Object.assign({}, this.state.videoConfig), { duration: action.videoDuration || 0 }),
                    });
                default:
                    return;
            }
        };
        /**
         * 对播放地址添加参数
         * @param {String} sourceUrl
         */
        this.addSrcParams = (sourceUrl, params) => {
            // 判断原链接是否已有参数拼接
            if (sourceUrl.indexOf('?') > 0) {
                return `${sourceUrl}&${params}`;
            }
            return `${sourceUrl}?${params}`;
        };
        const { initData: { videoConfig = {}, playermsg = {} }, } = props;
        // 播放器默认配置
        const defaultPlayerMsg = {
            hasMargin: false,
            antiTheft: true,
            showPoster: true,
            showTitle: true,
            showController: true,
            showFullScreenBtn: true,
            m3u8Play: true,
        };
        this.state = {
            videoConfig,
            playermsg: mergeObj(defaultPlayerMsg, playermsg),
            videoReady: false,
            postShow: true,
            playBtnStatus: 'play',
            playBtnShow: true,
            currentTime: 0,
            titleShow: true,
            controllShow: true,
            shortTipsShow: true,
        };
        this.posterHasShow = false;
        this.maskShow = true;
    }
    componentDidMount() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let _playUrl = '';
                const { initData: { videoConfig, videoConfig: { guid, mobileUrl, playUrl, videoPlayUrl }, }, } = this.props;
                _playUrl = mobileUrl || playUrl || videoPlayUrl || '';
                if (_playUrl) {
                    const { playermsg: { m3u8Play, antiTheft }, } = this.state;
                    // 加tsl参数保证https跳转
                    _playUrl = this.addSrcParams(_playUrl, 'reqtype=tsl');
                    // 先进行m3u8格式播放的判断
                    if (canPlay('application/vnd.apple.mpegURL')) {
                        if (m3u8Play) {
                            // videoConfig.mobileUrl =
                            //     videoConfig.mobileUrl && videoConfig.mobileUrl.replace('.mp4', '/index.m3u8');
                        }
                    }
                    if (antiTheft) {
                        const callbackName = creatCallBackName('getVideoAuthPath');
                        const authConfig = yield jsonp(`https://shankapi.ifeng.com/feedflow/getVideoAuthUrl/${guid || createUid()}/${callbackName}`, {
                            jsonpCallback: callbackName,
                            cache: false,
                        });
                        let _authUrl = '';
                        if (authConfig && authConfig.data && authConfig.data.success && authConfig.data.authUrl) {
                            _authUrl = authConfig.data.authUrl;
                            // 对传入的地址进行清洗，如果已带参数则&符后增
                            _playUrl = this.addSrcParams(_playUrl, _authUrl);
                        }
                    }
                    videoConfig.mobileUrl = _playUrl.replace('http://ips.ifeng.com', 'https://ips.ifeng.com');
                    this.setState({
                        videoConfig,
                        videoReady: true,
                    });
                }
                else {
                    console.error('缺少播放地址字段：mobileUrl | playUrl | videoPlayUrl');
                }
            }
            catch (e) {
                console.error(e);
            }
        });
    }
    render() {
        return (React.createElement(VideoContext.Provider, { value: Object.assign({ dispatch: this.handleContentChange }, this.state) }, this.props.children));
    }
}
export default VideoContentProvider;
